// extracted by mini-css-extract-plugin
module.exports = {"container":"_175PhYiMncRBr4XJeRRjOX","visible":"_2KiqoVihdvC5XWWzWJm-JY","cancelBtn":"-rx6-_8_kT1uZ0Zgmlcwo","icon":"_1XRE77z1XetI2e44yZh0l8","saveBtn":"_3jUugtwZ-3UOxz-X6TCF53"};